module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns-house_access_03-742cddf54d9adc8981185d07852df0fa.jpg";